import { createTermTagManager } from '../../utils/createTermTagManager';

export const mortgagePossibleTagManager = createTermTagManager({
  jsonQueryKey: 'ipoteka',
  label: 'Возможна ипотека',
  id: 'mortgagePossible',
});
